import { FC } from 'react'
import { Icons } from '@assets'
import { Field } from 'formik'
import {
  StyleContentWrapper,
  StyleBox,
  StyleText,
  StyleWrapper,
  StyleContentColumn,
  StyleDescription,
} from './style'
import { StyleErrorMessage } from '../style'
import Svg from '../../svg'
interface ItemProps {
  label: string
  value: string
  description?: String
  icon?: keyof typeof Icons
}
interface ChooseBoxProps {
  items: ItemProps[]
  name: string
  onChange?: (value: string) => void
}

const ChooseBox: FC<ChooseBoxProps> = ({ name, items, onChange }) => {
  const handleChange = ({ form, value }: any) => {
    if (!!onChange) {
      onChange(value)
    } else {
      form.setFieldValue(name, value)
    }
  }
  return (
    <Field name={name}>
      {({ form, field, meta }: any) => {
        const hasError = !!meta.touched && !!meta.error
        return (
          <>
            <StyleWrapper>
              {items?.map((item: ItemProps) => {
                return (
                  <StyleBox
                    key={item?.value}
                    isSelected={field?.value == item?.value}
                    onClick={() => {
                      handleChange({
                        form,
                        value: item?.value,
                      })
                    }}
                  >
                    <StyleContentWrapper>
                      {!!item?.icon && (
                        <Svg svg={item?.icon} size={22} color={'primary'} />
                      )}
                      <StyleContentColumn>
                        <StyleText>{item?.label}</StyleText>
                        {!!item?.description && (
                          <StyleDescription>
                            {item?.description}
                          </StyleDescription>
                        )}
                      </StyleContentColumn>
                    </StyleContentWrapper>
                  </StyleBox>
                )
              })}
            </StyleWrapper>
            {!!hasError && <StyleErrorMessage>{meta?.error}</StyleErrorMessage>}
          </>
        )
      }}
    </Field>
  )
}

export default ChooseBox
